module.exports = __webpack_public_path__ + "img/IMG_20200718_012332.f2a01c23.jpg";